/* ts-custom.js – Tomatosharp Organic V2
   «Vis flere»: henter neste side via Section Rendering API og legger kortene
   til i product-list. Uten JS fungerer knappen som vanlig lenke. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ts-next]');
    if (!btn) return;
    var wrap = btn.closest('[data-ts-loadmore]');
    var list = (btn.closest('.shopify-section') || document).querySelector('product-list, .product-list');
    if (!wrap || !list || !window.fetch) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var pageUrl = new URL(btn.href, window.location.href);
    var fetchUrl = new URL(pageUrl.toString());
    fetchUrl.searchParams.set('section_id', btn.getAttribute('data-section-id'));
    fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.querySelector('product-list, .product-list');
        if (newList) {
          Array.prototype.slice.call(newList.children).forEach(function (child) {
            if (child.matches('product-card, .product-card')) list.appendChild(child);
          });
        }
        var shown = list.querySelectorAll('product-card, .product-card').length;
        var vist = wrap.querySelector('[data-ts-vist]');
        // Pakke 4b: data-ts-forskyvning = varer på sidene før den første som ble lastet (åpnet på ?page=N).
        if (vist) vist.textContent = shown + (parseInt(vist.getAttribute('data-ts-forskyvning'), 10) || 0);
        var next = doc.querySelector('[data-ts-next]');
        if (next) {
          btn.href = next.getAttribute('href');
          btn.removeAttribute('aria-busy');
        } else {
          btn.remove();
        }
        try { window.history.replaceState(null, '', pageUrl.toString()); } catch (err) {}
      })
      .catch(function () { window.location.href = btn.href; });
  });
})();

/* Verkstedsvideo: stopp ved redusert bevegelse, start først når den er synlig. */
(function () {
  var v = document.querySelector('.ts-verksted__video video');
  if (!v) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.pause(); v.removeAttribute('autoplay'); return; }
  if (!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { v.muted = true; v.play && v.play().catch(function () {}); } else { v.pause(); } });
  }, { threshold: 0.25 }).observe(v);
})();
/* Anmeldelsestall fra Loox: leser Loox sin trust badge (skjult) og skriver tallene inn i egen 4,9-blokk og hero-bevislinjen.
   Loox fyller badgen med script etter sidelast, så vi venter på den (observer + polling i inntil 15 s). Faller tilbake til manuelle tall. */
(function () {
  var kilde = document.querySelector('.ts-anm__widget[data-ts-kilde]');
  if (!kilde) return;
  var T = (window.tsTekst || {}).custom || {};
  function fyll(s, vars) { return String(s).replace(/{{\s*(\w+)\s*}}/g, function (_, k) { return vars[k]; }); }
  var ferdig = false;
  function sync() {
    if (ferdig) return true;
    var tekst = (kilde.textContent || '').replace(/\s+/g, ' ');
    var mR = tekst.match(/(\d[.,]\d)\s*\/\s*5/);
    if (!mR) return false;
    /* 1/11 2026: «reviews» for det engelske merket på /en/, ellers ble reservetallene stående. */
    var mN = tekst.replace(mR[0], ' ').match(/(\d[\d\s.,]*)\s*(?:anmeldelser|reviews)/i);
    if (!mN) return false;
    var rating = mR[1].replace(',', '.');
    var antall = mN[1].replace(/[\s.,]/g, '');
    if (!/^\d+$/.test(antall) || antall.length < 2) return false;
    var score = document.querySelector('.ts-anm__score');
    if (score && score.firstChild && score.firstChild.nodeType === 3) score.firstChild.nodeValue = rating;
    var ant = document.querySelector('.ts-anm__antall');
    if (ant) ant.textContent = '(' + antall + ')';
    var stjerner = document.querySelector('.ts-anm__stjerner');
    var vis = rating.replace('.', T.desimal || ','); /* Fase 2b: desimaltegn følger språket (4,9 / 4.9). */
    if (stjerner) stjerner.setAttribute('aria-label', fyll(T.av_5_stjerner, { rating: vis }));
    document.querySelectorAll('.ts-hero__bevis span').forEach(function (el) {
      var t = el.textContent;
      /* Fase 2b: bygg linja fra språkfila i stedet for å lete etter «av 5»/«anmeldelser», så den oppdateres på alle språk.
         Bare linjer som allerede viser et snitt (4,9 / 4.9) byttes; egen tekst uten tall i hero-innstillingen står urørt. */
      if (/\d[.,]\d/.test(t)) el.textContent = fyll(T.av_5_fra, { snitt: vis, antall: antall });
    });
    ferdig = true;
    return true;
  }
  if (sync()) return;
  var forsok = 0;
  var timer = setInterval(function () { forsok += 1; if (sync() || forsok > 30) clearInterval(timer); }, 500);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { if (sync()) mo.disconnect(); });
    mo.observe(kilde, { childList: true, subtree: true, characterData: true });
  }
})();

/* 16/9: «Passer sammen med» skjules når Prestige-blokken ender opp med færre enn to produkter (ett kort med prikker ser ødelagt ut). Kortene lastes av JS, så vi venter. */
(function () {
  function sjekk() {
    document.querySelectorAll('product-recommendations').forEach(function (r) {
      var c = r.querySelector('.complementary-products');
      if (!c) return;
      var n = c.querySelectorAll('.product-card, product-card').length;
      if (n > 0 && n < 2) { r.hidden = true; r.style.display = 'none'; }
    });
  }
  var t = 0, timer = setInterval(function () { t += 1; sjekk(); if (t > 20) clearInterval(timer); }, 500);
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(sjekk);
    document.querySelectorAll('product-recommendations').forEach(function (r) { mo.observe(r, { childList: true, subtree: true }); });
  }
})();

/* 17/9: iframes fra apper (Vipps, Klaviyo, Loox) mangler title – sett en generisk for skjermlesere. */
(function () {
  var T = (window.tsTekst || {}).custom || {};
  function fix() { document.querySelectorAll('iframe:not([title])').forEach(function (f) { f.setAttribute('title', T.tredjepart); }); }
  fix(); document.addEventListener('DOMContentLoaded', fix); window.addEventListener('load', fix);
  /* 4/10 2026: samlet til ett kall per 250 ms. Før kjørte querySelectorAll på hver eneste DOM-endring i hele dokumentet. */
  var t; var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 250); }); mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* Runde 79 (5/10 2026): flisbildene i megamenyen har loading="lazy" og ble først hentet når panelet åpnet seg.
   Bildet kom etter at panelet hadde tonet inn, og det hakket når man gikk fra meny til meny.
   Nå hentes alle flisene første gang pekeren eller tastaturfokus treffer headeren. Bare desktop med mus; mobilmenyen er urørt. */
(function () {
  var header = document.querySelector('x-header');
  if (!header || !window.matchMedia || !window.matchMedia('(min-width: 1000px) and (hover: hover)').matches) return;
  function varm() {
    header.querySelectorAll('.mega-menu img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  header.addEventListener('pointerenter', varm, { once: true });
  header.addEventListener('focusin', varm, { once: true });
})();

/* 4/10 2026: kurssiden og kursproduktet lenker til nyhetsbrevsiden med ?kilde=kurs. Da får påmeldingen også taggen kurs-varsel,
   så kursinteresserte kan skilles fra drop-lista. Bare denne ene verdien godtas; taggen leses aldri rett fra adressen. */
(function () {
  if (!/[?&]kilde=kurs(&|$)/.test(window.location.search)) return;
  document.querySelectorAll('input[name="contact[tags]"]').forEach(function (i) {
    if (i.value.indexOf('kurs-varsel') === -1) i.value += ',kurs-varsel';
  });
})();

/* 4/10 2026: slipepakken prises per variant (antall kniver). «Endre antall kniver» i kurven sender kunden hit med ?endre=1.
   Da skal det nye valget erstatte pakken som ligger i kurven, ikke legges ved siden av (1 + 3 kniver ga 1 178 kr mot 1 099 kr for 4).
   Uten ?endre=1 legges varen til som før, så to pakker i én ordre fortsatt er mulig. */
(function () {
  if (!/[?&]endre=1/.test(window.location.search) || !window.fetch) return;
  var handle = (window.location.pathname.split('/products/')[1] || '').split('/')[0];
  if (!handle) return;
  var slipp = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (slipp || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var knapp = e.submitter;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (i) { if (i.handle === handle) updates[i.key] = 0; });
        if (!Object.keys(updates).length) return;
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
      })
      .catch(function () {})
      .then(function () {
        slipp = true;
        try { if (form.requestSubmit) form.requestSubmit(knapp && knapp.form === form ? knapp : undefined); else form.submit(); }
        finally { slipp = false; }
      });
  }, true);
})();


/* Runde 41 (23/9 2026): «Utgått» (tomatosharp.lagerstatus) skal ikke få ventelistefanen fra Restock Rocket.
   Lagerlinja setter data-ts-lager="gone"; her får <html> klassen ts-utgatt, og CSS skjuler fanen. */
(function () {
  function utgatt() {
    if (document.querySelector('variant-inventory[data-ts-lager="gone"], variant-inventory[data-ts-lager="drop"]')) document.documentElement.classList.add('ts-utgatt');
  }
  utgatt(); document.addEventListener('DOMContentLoaded', utgatt); window.addEventListener('load', utgatt);
})();

/* 8/10 2026: lagerlinja på produktkort følger fargeprøven som er valgt (data fra product-card.liquid, data-ts-kortlager). */
(function () {
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('product-card input[data-variant-id]')) return;
    var kort = input.closest('product-card');
    var kilde = kort && kort.querySelector('script[data-ts-kortlager]');
    if (!kilde) return;
    var data;
    try { data = JSON.parse(kilde.textContent); } catch (err) { return; }
    var rad = data[input.getAttribute('data-variant-id')];
    if (!rad) return;
    var variantNavn = kort.querySelector('.ts-kort__variant');
    if (variantNavn && rad[2]) variantNavn.textContent = ' · ' + rad[2];
    if (!kort.querySelector('.ts-card-stock') && !rad[1]) return;
    var linje = kort.querySelector('.ts-card-stock');
    if (!rad[1]) { if (linje) linje.hidden = true; return; }
    if (!linje) {
      var pris = kort.querySelector('price-list, .price-list');
      if (!pris) return;
      linje = document.createElement('span');
      pris.insertAdjacentElement('afterend', linje);
    }
    linje.hidden = false;
    linje.className = 'ts-card-stock ts-card-stock--' + rad[0];
    linje.textContent = rad[1];
  });
})();

/* 8/10 2026: «Frustrert?»-meldingen på produktsiden følger lagerlinja når kunden bytter variant.
   Utsolgt = variant-inventory med klassen text-error, unntatt utgåtte og «En av en» (data-ts-lager="gone"). */
(function () {
  function oppdater(rot) {
    var melding = rot.querySelector('[data-ts-utsolgt]');
    var lager = rot.querySelector('variant-inventory');
    if (!melding || !lager) return;
    var utsolgt = lager.classList.contains('text-error') && lager.getAttribute('data-ts-lager') !== 'gone';
    melding.hidden = !utsolgt;
  }
  function start() {
    document.querySelectorAll('[data-ts-utsolgt]').forEach(function (melding) {
      var rot = melding.closest('.shopify-section') || document.body;
      oppdater(rot);
      new MutationObserver(function () { oppdater(rot); }).observe(rot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-ts-lager'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 9/10 2026: SKU-raden under «Spesifikasjoner» (ts-pdp-under) følger varianten. Varianten leses fra ?variant= i adressen
   eller fra skjemaet i produktseksjonen, som temaet tegner på nytt ved variantbytte. */
(function () {
  function start() {
    var kilde = document.querySelector('script[data-ts-sku-kart]');
    if (!kilde) return;
    var kart;
    try { kart = JSON.parse(kilde.textContent); } catch (e) { return; }
    var celle = document.querySelector('[data-ts-sku]');
    var rad = document.querySelector('[data-ts-sku-rad]');
    if (!celle || !rad) return;
    var skjema = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var produktSeksjon = skjema ? skjema.closest('.shopify-section') : null;
    function oppdater() {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (!id || !(id in kart)) {
        var inp = (produktSeksjon || document).querySelector('form[action*="/cart/add"] input[name="id"]');
        id = inp ? inp.value : null;
      }
      if (!id || !(id in kart)) return;
      var sku = kart[id] || '';
      celle.textContent = sku;
      rad.hidden = sku === '';
    }
    ['pushState', 'replaceState'].forEach(function (navn) {
      var orig = history[navn];
      history[navn] = function () { var r = orig.apply(this, arguments); setTimeout(oppdater, 0); return r; };
    });
    window.addEventListener('popstate', oppdater);
    document.addEventListener('change', function () { setTimeout(oppdater, 50); });
    if (produktSeksjon) new MutationObserver(function () { oppdater(); }).observe(produktSeksjon, { subtree: true, childList: true });
    oppdater();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 9/10 2026 (eiervalg): fast kjøpslinje fra start på mobil. Prestige viser product-sticky-bar bare når skjemaet er rullet forbi
   (bottom < 0). Her: synlig så lenge skjemaet ikke er i skjermen (over eller under) og footeren ikke er synlig. Bare under 700 px.
   product-rerender bytter ut linja ved variantbytte, derfor bindes nye elementer på nytt. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(max-width: 699px)').matches || !('IntersectionObserver' in window)) return;
  function bind(bar) {
    if (bar.hasAttribute('data-ts-sticky')) return;
    bar.setAttribute('data-ts-sticky', '1');
    var form = document.forms[bar.getAttribute('form')];
    if (!form) return;
    var footer = document.querySelector('.shopify-section--footer');
    var formIn = false, footerIn = false;
    /* Footeren ligger inne i #main, så padding der hjelper ikke. rootMargin = linjas høyde: linja skjules når skjemaet
       eller footeren er innenfor linjas høyde under skjermkanten, så det siste innholdet over footeren ikke havner bak den. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.target === form) formIn = e.isIntersecting; if (e.target === footer) footerIn = e.isIntersecting; });
      bar.classList.toggle('ts-sticky-start', !formIn && !footerIn);
    }, { rootMargin: '0px 0px ' + Math.ceil(bar.offsetHeight || 65) + 'px 0px' });
    io.observe(form);
    if (footer) io.observe(footer);
  }
  function start() {
    document.documentElement.classList.add('ts-sticky-js');
    document.querySelectorAll('product-sticky-bar').forEach(bind);
    /* product-rerender bytter ut hele wrapperen (replaceWith), så observer #main, ikke wrapperen */
    var main = document.getElementById('main') || document.body;
    new MutationObserver(function () { main.querySelectorAll('product-sticky-bar:not([data-ts-sticky])').forEach(bind); }).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Runde 85 (20/10 2026): K1 Den faste kjøpslinja (product-sticky-bar) sendte skjemaet rett og hoppet over Bolds påkrevde felt,
   så gravering for 200,- kunne havne i kurven uten tekst. Finnes Bolds kopi av kjøpsknappen (button.bold_clone) i skjemaet,
   klikker linja den i stedet, så Bold validerer som på hovedknappen. Står et felt med feil utenfor skjermen, rulles det fram.
   K4 Kjøp med tillegg tar ~2,3 s (Bold legger inn tilleggene ett og ett) uten svar på knappen de første ~1,3 s. Nå dempes
   kjøpsknappene (.ts-venter + aria-busy) og får teksten fra data-ts-venter-tekst (main-product.liquid) med en gang,
   til cart:change eller cart:error kommer. Reserve: tilbake etter 10 s. */
(function () {
  var reserve;
  function ferdig() {
    clearTimeout(reserve);
    document.querySelectorAll('button.ts-venter[type="submit"]').forEach(function (b) {
      b.classList.remove('ts-venter');
      b.removeAttribute('aria-busy');
      if (b.hasAttribute('data-ts-tekst')) { b.innerHTML = b.getAttribute('data-ts-tekst'); b.removeAttribute('data-ts-tekst'); }
    });
  }
  function vent(form) {
    var kilde = document.querySelector('[data-ts-venter-tekst]');
    var tekst = kilde ? kilde.getAttribute('data-ts-venter-tekst') : '';
    Array.prototype.forEach.call(form.elements, function (b) {
      if (b.type !== 'submit' || b.disabled || b.classList.contains('bold_hidden')) return;
      b.classList.add('ts-venter');
      b.setAttribute('aria-busy', 'true');
      if (tekst && !b.hasAttribute('data-ts-tekst')) { b.setAttribute('data-ts-tekst', b.innerHTML); b.textContent = tekst; }
    });
    clearTimeout(reserve);
    reserve = setTimeout(ferdig, 10000);
  }
  document.addEventListener('cart:change', ferdig);
  document.addEventListener('cart:error', ferdig);
  document.addEventListener('click', function (e) {
    var knapp = e.target.closest && e.target.closest('button[type="submit"]');
    var form = knapp && knapp.form;
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '') || knapp.classList.contains('bold_hidden')) return;
    if (knapp.classList.contains('ts-venter')) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var klone = form.querySelector('button.bold_clone');
    if (klone && knapp !== klone && form.querySelector('.bold_options')) {
      e.preventDefault(); e.stopImmediatePropagation();
      klone.click();
      return;
    }
    /* Bold validerer synkront i sin klikklytter; setTimeout lar den (og temaets submit) kjøre først. */
    setTimeout(function () {
      var feil = form.querySelector('.bold_option_error');
      if (feil) {
        var r = feil.getBoundingClientRect();
        if (r.top < 80 || r.bottom > window.innerHeight - 80) feil.scrollIntoView({ block: 'center' });
        var felt = feil.querySelector('input[type="text"], textarea');
        if (felt) felt.focus({ preventScroll: true });
        return;
      }
      if (!form.checkValidity()) return;
      vent(form);
    }, 0);
  }, true);
})();

/* 31/10 2026 kl. 15:10 (eier): flyttingen av Bold/gave/ønskeliste rundt kjøpsknappen er fjernet; original rekkefølge. */

/* UX-masterplan 31/10 2026 (p8a): «Lagt til» i kjøpsknappen i 0,3 s før kurvskuffen åpner, så kunden ser at klikket virket.
   Prestige sender variant:add på skjemaet og rett etter cart:change, som åpner skuffen. Her holdes cart:change igjen i 0,3 s
   (window, fangstfasen, før skuffen, K4 over og settet i ts-cart-addons.js), skjemaets kjøpsknapper viser «Lagt til»
   (ts.js.cart_addons.lagt_til) og en status-region sier det til skjermleseren. Så sendes hendelsen videre med tsLagtTil, så den
   ikke holdes to ganger; kurven, Bold-tilleggene og Bold-synken får den samme hendelsen som før, 0,3 s senere.
   K4 setter knappeteksten tilbake; knapper K4 ikke tok, settes tilbake her. Ingen animasjon, så ingenting å slå av ved redusert bevegelse. */
(function () {
  var tekst = window.tsTekst && window.tsTekst.cart_addons && window.tsTekst.cart_addons.lagt_til;
  if (!tekst) return;
  var skjema = null, status = null;
  document.addEventListener('variant:add', function (e) { skjema = e.target; }, true);
  window.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    var form = skjema;
    skjema = null;
    if (d.baseEvent !== 'variant:add' || d.tsLagtTil || !form || !form.elements) return;
    var knapper = Array.prototype.filter.call(form.elements, function (b) {
      return b.type === 'submit' && !b.classList.contains('bold_hidden');
    });
    if (!knapper.length) return;
    e.stopImmediatePropagation();
    knapper.forEach(function (b) {
      if (!b.hasAttribute('data-ts-tekst')) b.setAttribute('data-ts-tekst', b.innerHTML);
      b.classList.add('ts-lagt-til');
      b.textContent = tekst;
    });
    if (!status) {
      status = document.createElement('p');
      status.className = 'sr-only';
      status.setAttribute('role', 'status');
      document.body.appendChild(status);
    }
    status.textContent = '';
    requestAnimationFrame(function () { status.textContent = tekst; });
    setTimeout(function () {
      knapper.forEach(function (b) { b.classList.remove('ts-lagt-til'); });
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: Object.assign({}, d, { tsLagtTil: true }) }));
      knapper.forEach(function (b) {
        if (!b.hasAttribute('data-ts-tekst')) return;
        b.innerHTML = b.getAttribute('data-ts-tekst');
        b.removeAttribute('data-ts-tekst');
      });
    }, 300);
  }, true);
})();

/* 11/10 2026: anmeldelseslinja (ts-bevis, data-ts-loox-apne) åpner Loox sitt flytende anmeldelsesvindu
   («Happy customers reviews widget», LOOX.openHCFloater) i stedet for å gå til /pages/anmeldelser.
   Er Loox ikke lastet, eller holder kunden inne Cmd/Ctrl/Shift for ny fane, følges lenken som vanlig.
   24/10 2026: på berøringsskjerm går lenken til /pages/anmeldelser. Vinduet ble stående mørkt og tomt i flere sekunder
   på iPhone mens Loox lastet, og eier trodde det var ødelagt. */
document.addEventListener('click', function (e) {
  var lenke = e.target.closest && e.target.closest('a[data-ts-loox-apne]');
  if (!lenke || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (!window.LOOX || typeof window.LOOX.openHCFloater !== 'function') return;
  e.preventDefault();
  try { window.LOOX.openHCFloater(); } catch (feil) { window.location.href = lenke.href; }
});

/* Runde 88 (21/10 2026): iOS Safari ruller siden bak en åpen skuff selv om <html> har .lock (overflow: hidden). Adresselinja
   endrer da høyde, og skuffen (meny, kurv, søk, filter) flytter seg. Mens .lock står på, låses body med position: fixed, og
   scrollposisjonen settes tilbake når skuffen lukkes. Bare berøringsskjerm; PC er urørt. */
(function () {
  if (!window.matchMedia('(pointer: coarse)').matches) return;
  var html = document.documentElement, body = document.body, y = 0, laast = false;
  new MutationObserver(function () {
    var lock = html.classList.contains('lock');
    if (lock === laast) return;
    laast = lock;
    if (lock) {
      y = window.scrollY;
      body.style.position = 'fixed';
      body.style.top = -y + 'px';
      body.style.left = '0';
      body.style.right = '0';
    } else {
      body.style.position = body.style.top = body.style.left = body.style.right = '';
      window.scrollTo({ top: y, behavior: 'instant' });
    }
  }).observe(html, { attributes: true, attributeFilter: ['class'] });
})();

/* Engelsk prisformat. Butikkens pengeformat («1 499,-») er felles for alle språk i Shopify,
   så på andre språk enn norsk skriver vi om prisene til «1,499 kr» etter at siden er tegnet.
   Gjelder også priser som kommer inn senere (kurvskuff, varianter), via MutationObserver. Norsk berøres ikke. */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || 'nb').toLowerCase();
  if (lang === 'nb' || lang.indexOf('nb-') === 0 || lang === 'no') return;
  var re = /(\d{1,3}(?:[   ]\d{3})*),-/g;
  var hopp = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1 };
  function omskriv(t) {
    return t.replace(re, function (_, tall) { return tall.replace(/[   ]/g, ',') + ' kr'; });
  }
  function gaa(rot) {
    if (rot.nodeType === 3) {
      if (rot.nodeValue.indexOf(',-') > -1) { var n = omskriv(rot.nodeValue); if (n !== rot.nodeValue) rot.nodeValue = n; }
      return;
    }
    if (rot.nodeType !== 1 || hopp[rot.nodeName]) return;
    var w = document.createTreeWalker(rot, NodeFilter.SHOW_TEXT, null), x;
    while ((x = w.nextNode())) {
      if (x.parentNode && hopp[x.parentNode.nodeName]) continue;
      if (x.nodeValue.indexOf(',-') > -1) { var v = omskriv(x.nodeValue); if (v !== x.nodeValue) x.nodeValue = v; }
    }
  }
  gaa(document.body);
  new MutationObserver(function (m) {
    m.forEach(function (r) {
      if (r.type === 'characterData') gaa(r.target);
      else r.addedNodes.forEach(gaa);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

/* 25/10 2026 (eierfeil på iPhone): Instagram-appen fant ikke kontoen når lenka gikk på brukernavn («Finner ikke bruker»,
   også med www og med appens egen delelenke), mens nettadressen viser riktig konto. Derfor åpnes appen med konto-ID-en
   (38688400538, fra profilsiden) i stedet for navnet. Bare på mobil. Er appen ikke installert, går lenka til nettadressen etter 1 s.
   Bytter kontoen ID (ny konto), må tallet byttes her. */
(function () {
  var id = '38688400538';
  if (!/iPhone|iPad|Android/i.test(navigator.userAgent)) return;
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href*="instagram.com/"]');
    /* 1/11 2026: bare lenker til selve profilen. Reels og innlegg (/reel/, /p/ på slipeguide og målsom) skal åpne seg selv, ikke profilen. */
    if (!a || !/^https?:\/\/(www\.)?instagram\.com\/tomatosharp(\.no)?\/?([?#].*)?$/i.test(a.href)) return;
    ev.preventDefault();
    var url = a.href;
    /* Kald start av appen tar over 1 s på iPhone. Da rakk reservelenka å gå til nettadressen, som appen igjen slo opp på navn og feilet.
       Nå 3 s, og avbrytes så snart Safari mister fokus eller skjules. */
    var t = setTimeout(function () { window.location.href = url; }, 3000);
    var stopp = function () { clearTimeout(t); };
    window.addEventListener('blur', stopp, { once: true });
    window.addEventListener('pagehide', stopp, { once: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stopp(); }, { once: true });
    window.location.href = 'instagram://user?id=' + id;
  });
})();

/* 25/10 2026 (QA-funn): kom kunden tilbake fra kassen med tilbakeknappen, viste kurvskuffen en gammel kurv. Safari henter siden fra minnet
   (bfcache), og Prestiges egen oppdatering henter seksjonen med GET, som Safari også kan ta fra cache. Her hentes /cart.js uten cache,
   og er antallet et annet enn det siden viser, lastes siden på nytt. */
(function () {
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(Shopify.routes.root + 'cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Telleren i headeren finnes bare på desktop; på mobil telles varelinjene som alt ligger i skuffen. */
        /* 1/11 2026: sammenlign likt med likt. Telleren viser antall uten Bolds skjulte linjer og returfrakten (ts-cart-addons.js), og skuffen
           tegner ikke Bolds skjulte linjer eller slipetilleggene (ts-sliping-gruppe). Ellers lastet siden på nytt hver gang med et tillegg i kurven. */
        var ca = window.__tsCartAddons || {};
        var skygge = ca.isShadow || function () { return false; };
        var hoved = {};
        cart.items.forEach(function (i) { var b = i.properties && i.properties._bestilling; if (b && i.handle !== 'tilleggstjenester-sliping') hoved[b] = 1; });
        var vist = document.querySelector('cart-count');
        var tall = vist ? parseInt(vist.textContent, 10) : document.querySelectorAll('cart-drawer line-item').length;
        var fasit = vist ? (ca.visibleCount ? ca.visibleCount(cart) : cart.item_count)
          : cart.items.filter(function (i) { return !skygge(i) && !(i.handle === 'tilleggstjenester-sliping' && hoved[(i.properties || {})._bestilling]); }).length;
        if (!isNaN(tall) && tall !== fasit) window.location.reload();
      })
      .catch(function () {});
  });
})();

/* Menylenken «Masterclass» under Bedrift peker til /pages/bedrift#masterclass.
   Kortene i «Det du får» har ikke egne ankere i Prestige, så vi finner kortet på tittelen
   og scroller dit. Plass til den faste headeren over. */
(function () {
  if (location.hash !== '#masterclass') return;
  window.addEventListener('load', function () {
    var kort = Array.prototype.find.call(document.querySelectorAll('.multi-column__item'), function (el) {
      return /Masterclass/.test(el.textContent);
    });
    if (!kort) return;
    kort.style.scrollMarginTop = '80px';
    kort.scrollIntoView({ block: 'start' });
  });
})();

/* 27/10 2026 (f5, QA-funn): Loox legger en tom, fokuserbar lenke (<a href="#looxReviewsFrame">, 0×0, engelsk «Scroll to reviews») ved stjernene
   på produktsiden. Tastaturfokus forsvant inn i den. Tas ut av tab-rekkefølgen og skjules for skjermleser. */
(function () {
  function rydd(rot) {
    (rot.querySelectorAll ? rot.querySelectorAll('a[href="#looxReviewsFrame"]') : []).forEach(function (a) {
      if (a.textContent.trim()) return;
      a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true');
    });
  }
  rydd(document);
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) rydd(n); }); }); }).observe(document.body, { childList: true, subtree: true });
})();

/* 30/10 2026 (eier): Bold Product Options viser opsjonene på norsk også på /en/. Navnene er en kontrakt med Bold og kurven
   (properties[Legg til knivbeskytter], ts-cart-addons.js), så bare den synlige teksten byttes, og bare på engelsk. */
(function () {
  if (document.documentElement.lang !== 'en') return;
  var tekst = {
    'Personlig inngravering': 'Personal engraving', 'Inngravering av logo': 'Logo engraving', 'Legg til knivbeskytter': 'Add knife guard',
    'Tekst': 'Text', 'Skrifttype': 'Font', 'Navn eller hilsen': 'Name or greeting'
  };
  // «Forhåndsvisning» er med vilje utelatt: Bold skriver tittelen på nytt ved hver endring, og et bytte der gir en evig løkke.
  function bytt(rot) {
    // Ny node inne i Bold-boksen skannes selv; ellers letes boksene opp. Påkrevde felt har stjernen i samme tekst («Tekst*»).
    var bokser = rot.closest && rot.closest('.bold_options') ? [rot] : (rot.querySelectorAll ? rot.querySelectorAll('.bold_options') : []);
    Array.prototype.forEach.call(bokser, function (boks) {
      var w = document.createTreeWalker(boks, NodeFilter.SHOW_TEXT), n, t;
      while ((n = w.nextNode())) { t = n.nodeValue.trim().replace(/\*$/, ''); if (tekst[t]) n.nodeValue = n.nodeValue.replace(t, tekst[t]); }
      boks.querySelectorAll('[placeholder]').forEach(function (f) { var p = f.getAttribute('placeholder'); if (tekst[p]) f.setAttribute('placeholder', tekst[p]); });
    });
  }
  bytt(document);
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.nodeType === 1) bytt(n); }); }); }).observe(document.body, { childList: true, subtree: true });
})();

/* 30/10 2026 (eier): Bold skriver tilleggsprisen i kroner med kundens valutategn («€200,00» for gravering til 200 kr).
   Utenfor kronemarkedet hentes tilleggsvarens pris fra /products/<handle>.js, som gir prisen i kundens valuta, den samme som
   kurven tar, og den skrives inn i stedet. Varen finnes via data-product-handle på avkrysningsboksen i samme Bold-opsjon. */
(function () {
  var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
  if (!cur || cur === 'NOK') return;
  var fmt = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '{{amount}}';
  var rot = (Shopify.routes && Shopify.routes.root) || '/';
  var priser = {};
  // Shopifys pengeformater: comma_separator = 1.234,56, space_separator = 1 234,56, apostrophe = 1'234.56, amount = 1,234.56.
  function penger(ore) {
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), navn = m ? m[1] : 'amount';
    var tus = /comma_separator/.test(navn) ? '.' : /space_separator/.test(navn) ? ' ' : /apostrophe_separator/.test(navn) ? "'" : ',';
    var des = /comma_separator|space_separator/.test(navn) ? ',' : '.';
    var deler = (ore / 100).toFixed(/no_decimals/.test(navn) ? 0 : 2).split('.');
    var tall = deler[0].replace(/\B(?=(\d{3})+(?!\d))/g, tus) + (deler[1] ? des + deler[1] : '');
    return m ? fmt.replace(m[0], tall) : tall;
  }
  function pris(handle) {
    if (!priser[handle]) priser[handle] = fetch(rot + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { return p.variants[0].price; });
    return priser[handle];
  }
  function fiks(boks) {
    boks.querySelectorAll('.bold_option_value_price').forEach(function (span) {
      var valg = span.closest('.bold_option'), boksen = valg && valg.querySelector('[data-product-handle]');
      if (!boksen || span.hasAttribute('data-ts-gratis')) return;
      pris(boksen.getAttribute('data-product-handle')).then(function (ore) {
        var t = penger(ore);
        if (span.hasAttribute('data-ts-gratis')) return; // 2/11: gratis gravering vises av blokken under
        // Sikring mot en evig dragkamp hvis Bold skriver prisen tilbake hver gang: maks 10 bytter per pris.
        if (span.textContent === t || (span._tsBytt = (span._tsBytt || 0) + 1) > 10) return;
        span.textContent = t;
      }).catch(function () {});
    });
  }
  document.querySelectorAll('.bold_options').forEach(fiks);
  new MutationObserver(function (m) {
    m.forEach(function (r) {
      var el = r.target.nodeType === 1 ? r.target : r.target.parentElement, boks = el && el.closest('.bold_options');
      if (boks) return fiks(boks);
      r.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.querySelectorAll) n.querySelectorAll('.bold_options').forEach(fiks); });
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

/* 2/11 2026 (eier): gratis gravering i november. Pengene trekkes av en automatisk rabatt i admin; her vises bare at den gjelder,
   som «200,-» gjennomstreket og «Gratis» i Bold-valget. Flagget settes av ts-cart-includes ut fra «Gratis gravering til og med»
   (Tomatosharp: Handlekurv), så visningen forsvinner av seg selv etter datoen. Utenfor kronemarkedet står bare «Gratis». */
(function () {
  if (!document.querySelector('[data-ts-grav-gratis]')) return;
  var gravering = ['personlig-inngravering', 'personlig-inngravering-1', 'inngravering-av-logo'];
  var en = document.documentElement.lang === 'en', gratis = en ? 'Free' : 'Gratis', for_ = en ? 'Was ' : 'Før ';
  var nok = !(window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== 'NOK');
  function merk(rot) {
    rot.querySelectorAll('.bold_option_value_price').forEach(function (span) {
      var valg = span.closest('.bold_option'), boksen = valg && valg.querySelector('[data-product-handle]');
      if (!boksen || gravering.indexOf(boksen.getAttribute('data-product-handle')) < 0) return;
      if (span.querySelector('s') || (span._tsGratis = (span._tsGratis || 0) + 1) > 10) return; // maks 10 om Bold skriver prisen tilbake
      span.setAttribute('data-ts-gratis', '');
      var pris = span.textContent.trim();
      span.innerHTML = (nok && pris ? '<s><span class="sr-only">' + for_ + '</span>' + pris + '</s> ' : '') + gratis;
    });
  }
  merk(document);
  new MutationObserver(function (m) {
    m.forEach(function (r) {
      var el = r.target.nodeType === 1 ? r.target : r.target.parentElement, boks = el && el.closest('.bold_options');
      if (boks) return merk(boks);
      r.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.querySelectorAll) merk(n); });
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

/* Landvelgeren (2/11): søkefeltet skjuler land som ikke passer og grupper som blir tomme.
   Enter velger første treff, så «sver» + Enter er nok. Uten JS vises hele lista som før. */
(function () {
  function norm(s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function treff(form) { return form.querySelectorAll('[role="option"]:not([hidden])'); }

  document.addEventListener('input', function (e) {
    var felt = e.target.closest && e.target.closest('[data-ts-land-sok]');
    if (!felt) return;
    var form = felt.form, q = norm(felt.value.trim());
    form.querySelectorAll('[role="option"]').forEach(function (o) {
      o.hidden = q !== '' && norm(o.textContent + ' ' + o.value).indexOf(q) === -1;
    });
    form.querySelectorAll('[data-ts-land-gruppe]').forEach(function (g) {
      g.hidden = !g.querySelector('[role="option"]:not([hidden])');
    });
    form.querySelector('[data-ts-land-tomt]').hidden = treff(form).length > 0;
  });

  document.addEventListener('keydown', function (e) {
    var felt = e.key === 'Enter' && e.target.closest && e.target.closest('[data-ts-land-sok]');
    if (!felt) return;
    e.preventDefault();
    var forste = treff(felt.form)[0];
    if (felt.value.trim() && forste) forste.click();
  });
})();
